"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataFromCRM = void 0;
var env_1 = require("dingtalk-jsapi/lib/env");
var common_1 = require("./common");
var mobile_1 = __importDefault(require("./mobile"));
var pc_1 = __importDefault(require("./pc"));
var platform = env_1.getENV().platform;
/**
 * 客户管理授权客户敏感数据前端api，调用后会在钉钉端内打开
 * @category biz/CRM
 * @module biz/CRM
 * @param {Object} params 参数
 * @param {string} params.corpId 企业id
 * @param {string} params.instanceId 数据id
 * @param {string} params.upgradeType 开放平台upgradeType
 * @param {string} params.suiteKey 开放平台ISV所使用的suiteKey，以‘suite’开头
 * @support pc web
 * @returns {Promise} 成功、失败
 * @example
 * getDataFromCRM({
 *     corpId: 'dingxxxxxx',
 *     instanceId: 'exxx-axxxx-xxxxxx-xxxxx',
 *     upgradeType: 'xxxxx',
 *     suiteKey: 'suitexxxx',
 * }).then(() => {
 *     toast('授权成功', 'success');
 * }).catch(() => {
 *     // 用户已经取消
 * });
 */
function getDataFromCRM(params) {
    return new Promise(function (resolve, reject) {
        var ok = function () {
            resolve && resolve('success');
        };
        var error = function (e) {
            reject && reject(e);
        };
        common_1.checkHasAuth(params.corpId, params.suiteKey, params.instanceId)
            .then(function () {
            ok();
        })
            .catch(function () {
            if (platform === 'ios' || platform === 'android') {
                return mobile_1.default(params)
                    .then(function () {
                    ok();
                })
                    .catch(function (e) {
                    error(e);
                });
            }
            return pc_1.default(params)
                .then(function () {
                ok();
            })
                .catch(function (e) {
                error(e);
            });
        });
    });
}
exports.getDataFromCRM = getDataFromCRM;



//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-design-libs/biz/CRM/getData/index.js
// module id = oM/1
// module chunks = 0